import { Avatar, Stack, Typography } from "@mui/material";
import React from "react";

function StandardDataItem({ title, text, icon, iconColor }) {
  return (
    <Stack direction={"row"} spacing={2}>
      <Avatar
        sx={{
          bgcolor: iconColor,
          color: "#FFFFFF",
          alignSelf: "center",
        }}
        variant="rounded"
      >
        {icon}
      </Avatar>
      <Stack>
        <Typography whiteSpace={'nowrap'} variant="body2" color="text.secondary">
          {title}
        </Typography>
        <Typography whiteSpace={'nowrap'} variant="body1">{text}</Typography>
      </Stack>
    </Stack>
  );
}

export default StandardDataItem;
